import React from "react";
import PropTypes from "prop-types";
import { Field } from "formik";
import Textarea from "../../Textarea/Textarea";

function TextareaField(props) {
    const { className, fieldName, type, helperText, onChange, label, fullWidth, ...rest } = props;

    const onChangeHandler = (event, field, form) => {
        field.onChange(event);
        if (onChange && typeof onChange === "function") {
            onChange(field.name, event && event.target && event.target.value, form);
        }
    };

    return (
        <Field type={type} name={fieldName}>
            {({ field, form }) => {
                const error = form.touched[field.name] && form.errors[field.name];

                return (
                    <Textarea
                        {...field}
                        {...rest}
                        id={field.name}
                        onChange={(e) => onChangeHandler(e, field, form)}
                        label={label}
                        error={error}
                        helperText={helperText}
                        fullWidth
                    />
                );
            }}
        </Field>
    );
}

TextareaField.propTypes = {
    fieldName: PropTypes.string.isRequired,
    fullWidth: PropTypes.bool,
    helperText: PropTypes.string,
    onChange: PropTypes.func,
    label: PropTypes.string,
    className: PropTypes.string,
    rows: PropTypes.number,
    maxLength: PropTypes.number,
};

TextareaField.defaultProps = {
    fullWidth: true,
    helperText: undefined,
    onChange: undefined,
    label: undefined,
    className: undefined,
    rows: 10,
    maxLength: undefined,
};

export default TextareaField;
